import React, { useContext, useEffect, useState } from 'react'
import ProductTable from '../tablets/ProductTable'
import { Product } from '../../models/Product'
import { PromiseSesionContext } from '../../machines/ErrorMachine'
import { useDebounce } from '../../hooks/useDebounce'
import { getAllCardsInventary } from '../../api/Products'

interface Props{
   loading:boolean
   setLoading:React.Dispatch<React.SetStateAction<boolean>>
   categories:string
   franchise:string
   status:string
   name:string
   setTotal?: React.Dispatch<React.SetStateAction<number>>
}

const ProductListTable = ({loading, setLoading, status, categories, franchise, setTotal, name}:Props) => {
  const [allProducts, setAllProducts] = React.useState<Product[]>([]);
  const {sendError} = useContext(PromiseSesionContext);

  const debouncedCategory = useDebounce(categories, 700);
  const debouncedFranchise= useDebounce(franchise, 700);
  const debouncedStatus = useDebounce(status, 700);
  const debouncedName = useDebounce(name, 700);


  //paginate
  const [page, setPage] = useState<number>(1)
  const [limitPage, setLimitPage] = useState<number>(5)

  const [totalPage, setTotalPage] = useState<number>(0)
  const [totalElements, setTotalElements] = useState<number>(0)

    const getProducts = async ()=>{
        try{
        setLoading(true);
        const response =  await getAllCardsInventary(page, limitPage, name, categories, franchise, status)
        if(response.total!== totalElements){
          setPage(1)
        }
        setAllProducts(response.products)
        // setFilteredProducts(response.products); 
        setTotalPage(response.last_page)
        setTotalElements(response.total)
        if(setTotal){
          setTotal(response.total)
        }
        setLoading(false);
        }
        catch(error){
        setLoading(false);
        sendError({type: "ERROR", data:{message:"Error al cargar el inventario.", type:"error"}})

        }
    }

    useEffect(() => {
      getProducts()
    }, [page,debouncedCategory, debouncedFranchise, debouncedStatus, debouncedName ]);

  return (
    <ProductTable 
    onRefresh={()=>{getProducts()}}
    loading={loading}
    products={allProducts}
    current={page} pageSize={limitPage}
    total={totalElements}
    setPage={setPage} />
  )
}

export default ProductListTable